module.exports = __webpack_public_path__ + "static/media/money-campaign.dd600d7b.svg";